import React from 'react'
import {
    Button,
    message,
    Col,
    ConfigProvider,
    DatePicker,
    Pagination,
    Row,
    Table,
    Spin
} from 'antd'
import {ReloadOutlined} from '@ant-design/icons'
import './index.less'
import zhCN from "antd/es/locale/zh_CN";
import {getFinanceListShop} from '../../constants/api'
import {removeToken} from "../../utils/cookie";
import moment from "moment";
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD HH:mm:ss';

export default class Finance extends React.Component {

    state = {
        dataLoading:false,
        financeList: [],
        financeListCurrent: 1,
        financeListPagesize: 10,
        financeListTotal: 0,
        pageMoney: '0',
        totalMoney: '0',
        pageAfterSaleMoney:0,
        totalAfterSaleMoney:0,
        totalGetMoney:0,

        orderStart:  moment().format('YYYY-MM-DD'),//开始时间
        orderEnd:  moment().format('YYYY-MM-DD'),//结束时间
    }

    componentDidMount() {
        this.searchFinance(1, 10, this.state.orderStart, this.state.orderEnd)
    }

    searchFinance = (current, size, orderStart, orderEnd) => {
        this.setState({dataLoading: true})
        getFinanceListShop({
            pageIndex: current,
            pageSize: size,
            sortName: "",
            sortType: "",
            startTime: orderStart,
            endTime: orderEnd,
        }).then((res) => {
            this.setState({dataLoading: false})
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    if (data.data != null) {
                        if (data.data.data) {
                            this.setState({
                                financeList: data.data.data.records,
                                financeListTotal: data.data.data.total,
                                pageMoney: data.data.pageMoney,
                                totalMoney: data.data.totalMoney,
                                pageAfterSaleMoney:data.data.pageAfterSaleMoney,
                                totalAfterSaleMoney:data.data.totalAfterSaleMoney,
                                totalGetMoney:data.data.totalGetMoney
                            })
                        } else {
                            message.success('无数据')
                            this.setState({
                                financeList: [],
                                financeListTotal: 0,
                                pageMoney: data.data.pageMoney,
                                totalMoney: data.data.totalMoney,
                                pageAfterSaleMoney:data.data.pageAfterSaleMoney,
                                totalAfterSaleMoney:data.data.totalAfterSaleMoney,
                                totalGetMoney:data.data.totalGetMoney
                            })
                        }
                    } else {
                        message.success('无数据')
                        this.setState({
                            financeList: [],
                            financeListTotal: 0,
                            pageMoney: 0,
                            totalMoney: 0,
                            pageAfterSaleMoney:0,
                            totalAfterSaleMoney:0,
                            totalGetMoney:0
                        })
                    }
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            this.setState({dataLoading: false})
            message.error(error.toString())
        })
    }
    onChangePageManage = (page, pageSize) => {
        this.setState({financeListCurrent: page}, () => {
            this.searchFinance(page, this.state.financeListPagesize, this.state.orderStart, this.state.orderEnd)
        })
    }
    onChangeSizeManage = (current, size) => {
        this.setState({financeListPagesize: size})
    }

    onSelectChange = selectedRowKeys => {
        // console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({selectedRowKeys});
    };

    onChangeOrderTimeS(date, dateString) {
        // console.log(dateString)
        this.setState({
            orderStart: dateString
        })
    }
    onChangeOrderTimeE(date, dateString) {
        // console.log(dateString)
        this.setState({
            orderEnd: dateString
        })
    }

    onChangeOrderTime(date, dateString) {
        // console.log(dateString)
        this.setState({
            orderStart: dateString[0],
            orderEnd: dateString[1]
        })
    }

    searchCurrentFinance = () => {
        const {orderStart, orderEnd} = this.state
        this.searchFinance(1, this.state.financeListPagesize, orderStart, orderEnd)
    }

    refreshCurrentFinance = () => {
        this.setState({
            orderStart: '',
            orderEnd: '',
        })
        this.searchFinance(1, this.state.financeListPagesize, '', '')
    }

    render() {
        const columnsFinance = [
            {
                title: '取单号',
                dataIndex: 'orderNum',
            },
            {
                title: '订单号',
                dataIndex: 'orderNo',
            },
            {
                title: '收货人',
                dataIndex: 'userName',
            },
            {
                title: '付款时间',
                dataIndex: 'payTime',
            },
            {
                title: '送达时间',
                dataIndex: 'sendTime',
            },
            {
                title: '总价',
                dataIndex: 'totalAmount',
            },
            {
                title: '最后售后时间',
                dataIndex: 'afterSaleTime',
            },
            {
                title: "售后状态",
                render:(text,record)=>(
                    record.afterSaleStatus==1?<span style={{color:'#1989FA'}}>第一次售后</span>:
                        record.afterSaleStatus==2?<span style={{color:'#1989FA'}}>商家同意</span>:
                            record.afterSaleStatus==3?<span style={{color:'red'}}>商家拒绝</span>:
                                record.afterSaleStatus==5?<span style={{color:'#1989FA'}}>第二次售后</span>:
                                    record.afterSaleStatus==6?<span style={{color:'#1989FA'}}>第二次商家同意</span>:
                                        record.afterSaleStatus==7?<span style={{color:'red'}}>第二次商家拒绝</span>:
                                            record.afterSaleStatus==10?<span style={{color:'#1989FA'}}>客服介入</span>:
                                                record.afterSaleStatus==11?<span style={{color:'#1989FA'}}>客服已同意</span>:
                                                    record.afterSaleStatus==12?<span style={{color:'red'}}>客服已拒绝</span>:
                                                        record.afterSaleStatus==-1?<span style={{color:'red'}}>已取消</span>:
                                                            record.afterSaleStatus==-100?<span style={{color:'red'}}>已删除</span>:
                                                                '无'
                )
            },
            {
                title: "售后金额",
                //dataIndex: 'afterSaleAmount',
                render:(text,record)=>(
                    <span style={{color:'red'}}>￥{record.afterSaleAmount}</span>
                )
            },
        ];

        let {financeList} = this.state;

        return (
            <div className='container'>
                <ConfigProvider locale={zhCN}>
                    <Row style={{marginRight: 190, marginBottom: -15, padding: '20px 20px 20px 30px'}} gutter={[8, 8]}>
                        {/*<Col className="gutter-row" span={6}>*/}
                        {/*    <RangePicker showTime*/}
                        {/*                 value={(this.state.orderStart === ''||this.state.orderEnd === '')? null:*/}
                        {/*                     [moment(this.state.orderStart, dateFormat), moment(this.state.orderEnd, dateFormat)]}*/}
                        {/*                 className="header-search"*/}
                        {/*                 placeholder={['下单开始时间', '下单结束时间']}*/}
                        {/*                 onChange={this.onChangeOrderTime.bind(this)}/>*/}
                        {/*</Col>*/}
                        <Col className="gutter-row" span={3}>
                            <DatePicker
                                // showTime
                                value={(this.state.orderStart === '') ? null : moment(this.state.orderStart, dateFormat)}
                                className="header-search"
                                placeholder={'开始时间'}
                                onChange={this.onChangeOrderTimeS.bind(this)}/>
                        </Col>
                        <Col className="gutter-row" span={3}>
                            <DatePicker
                                // showTime
                                value={(this.state.orderEnd === '') ? null : moment(this.state.orderEnd, dateFormat)}
                                className="header-search"
                                placeholder={'结束时间'}
                                onChange={this.onChangeOrderTimeE.bind(this)}/>
                        </Col>
                        <Col className="gutter-row" span={5}>
                            <Button type="primary" onClick={this.searchCurrentFinance.bind(this)}>
                                搜索
                            </Button>
                            <Button type="primary" style={{marginLeft: 5}} onClick={this.refreshCurrentFinance.bind(this)}>
                                <ReloadOutlined />
                            </Button>
                        </Col>
                    </Row>
                    <div className="container-total">
                        <span style={{fontSize: 18, color: '#121212', fontWeight: 'bold'}}>统计</span>
                        <span style={{fontSize: 14, color: '#121212'}}>当前条件下，订单总价：
                            <span style={{fontSize: 16, fontWeight: 'bold', color: '#ff0000'}}>￥{this.state.totalMoney}</span>
                            <span>，当前条件下，总退款金额：</span>
                            <span style={{fontSize: 16, fontWeight: 'bold', color: '#ff0000'}}>￥{this.state.totalAfterSaleMoney}</span>
                            <span>，总可结算金额：</span>
                            <span style={{fontSize: 16, fontWeight: 'bold', color: '#ff0000'}}>￥{this.state.totalGetMoney}</span>
                            <span style={{fontSize: 14, color: '#121212'}}>，当前页面，累计金额：</span>
                            <span style={{fontSize: 16, fontWeight: 'bold', color: '#ff0000'}}>￥{this.state.pageMoney}</span>
                            <span>，当前页面，累计退款金额：</span>
                            <span style={{fontSize: 16, fontWeight: 'bold', color: '#ff0000'}}>￥{this.state.pageAfterSaleMoney}</span>
                        </span>
                    </div>
                </ConfigProvider>
                <Col>
                    <div style={{padding: '0 10px 0 10px'}}>
                        <Spin size="large" spinning={this.state.dataLoading}>
                        <Table rowKey="orderNo"
                               bordered = {true}
                            // rowSelection={rowSelection}
                               columns={columnsFinance}
                               pagination={false}
                               dataSource={financeList}/>
                        </Spin>
                        <ConfigProvider locale={zhCN}>
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-end",
                                marginTop: 10,
                                marginRight: 20,
                                marginBottom: 20
                            }}>
                                <Pagination style={{marginTop: 5}} showQuickJumper={true}
                                            onShowSizeChange={this.onChangeSizeManage}
                                            current={this.state.financeListCurrent}
                                            pageSize={this.state.financeListPagesize}
                                            total={this.state.financeListTotal}
                                            onChange={this.onChangePageManage}/>
                            </div>
                        </ConfigProvider>
                    </div>
                </Col>
            </div>
        );

    }
}




// WEBPACK FOOTER //
// ./src/pages/finance/index.js